import { Link2, Loader2 } from "lucide-react";

type UrlInputPanelProps = {
  url: string;
  isImporting: boolean;
  importMessage: string;
  onUrlChange: (url: string) => void;
  onImport: () => void;
};

export function UrlInputPanel({
  url,
  isImporting,
  importMessage,
  onUrlChange,
  onImport,
}: UrlInputPanelProps) {
  return (
    <section aria-labelledby="url-input-heading">
      <h3 id="url-input-heading" className="text-sm font-semibold text-ink">
        LinkedIn post URL
      </h3>
      <div className="mt-2 flex flex-col gap-2 sm:flex-row">
        <label className="sr-only" htmlFor="linkedin-url">
          LinkedIn post URL
        </label>
        <input
          id="linkedin-url"
          value={url}
          onChange={(event) => onUrlChange(event.target.value)}
          placeholder="https://www.linkedin.com/posts/..."
          className="min-h-11 flex-1 rounded-lg border border-slate-300 bg-white px-3 text-sm text-ink shadow-sm transition placeholder:text-slate-400 hover:border-slate-400"
          inputMode="url"
        />
        <button
          type="button"
          onClick={onImport}
          disabled={isImporting}
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-lg bg-ocean px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-[#0f5d81] disabled:cursor-not-allowed disabled:opacity-70"
        >
          {isImporting ? (
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
          ) : (
            <Link2 className="h-4 w-4" aria-hidden="true" />
          )}
          Get Post
        </button>
      </div>
      {importMessage ? (
        <p className="mt-2 rounded-lg border border-sky-200 bg-sky-50 px-3 py-2 text-sm text-sky-900">
          {importMessage}
        </p>
      ) : null}
    </section>
  );
}
